import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import { db, auth } from './firebase'; 
import { getDoc, doc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';

function App() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const initialCheckRef = useRef(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthChecked(true);
      
      if (initialCheckRef.current) {
        if (currentUser) {
          setIsUnlocked(true);
        }
        initialCheckRef.current = false;
      } else if (!currentUser) {
        // Reset the unlock state when the user logs out manually
        setIsUnlocked(false);
      }
    });

    const verifyFirebase = async () => {
      try {
        await getDoc(doc(db, 'u-jarvis-status', 'ping'));
        console.log("%c>> U-JARVIS: FIREBASE_CLOUD_LINK_ESTABLISHED ✓", "color: #39FF14; font-weight: bold; text-shadow: 0 0 5px #39FF14;");
      } catch (err) {
        console.log("%c>> U-JARVIS: FIREBASE_OFFLINE_OR_PERMISSION_DENIED ✗", "color: #ff3131; font-weight: bold;");
      }
    };

    verifyFirebase();
    return () => unsubscribe();
  }, []);

  if (!authChecked) {
    return <div style={{height: '100vh', background: '#050300'}} /> // Black screen while checking auth
  }

  return (
    <div className="App">
      {!isUnlocked || !user ? (
        <LandingPage onUnlock={() => setIsUnlocked(true)} />
      ) : (
        <Dashboard user={user} />
      )}
    </div>
  );
}

export default App;